export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Диагностика потребностей',
      description: 'Анализ текущей ситуации, интервью с руководителями, опросы сотрудников, определение целей и KPI.',
      icon: 'ri-search-eye-line',
    },
    {
      number: '02',
      title: 'Выбор программы',
      description: 'Подбор оптимальных форматов, модулей и методик под специфику бизнеса и уровень команды.',
      icon: 'ri-list-check-3',
    },
    {
      number: '03',
      title: 'Проведение обучения',
      description: 'Интерактивные тренинги, бизнес-игры, воркшопы и практические сессии с разбором реальных кейсов.',
      icon: 'ri-presentation-line',
    },
    {
      number: '04',
      title: 'Практика',
      description: 'Закрепление навыков через домашние задания, менторские сессии и работу с реальными задачами бизнеса.',
      icon: 'ri-tools-line',
    },
    {
      number: '05',
      title: 'Сопровождение',
      description: 'Посттренинговая поддержка, консультации, корректировка программ и ответы на вопросы участников.',
      icon: 'ri-customer-service-2-line',
    },
    {
      number: '06',
      title: 'Измерение результатов',
      description: 'Оценка по модели Киркпатрика, расчёт ROI, анализ изменений в KPI и бизнес-показателях компании.',
      icon: 'ri-bar-chart-2-line',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Как выбрать программу обучения
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Проверенная методология — от диагностики до измерения бизнес-результатов. Каждый этап важен для достижения целей.
          </p>
        </div>

        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-9 top-0 bottom-0 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="flex flex-col gap-8">
            {steps.map((step, index) => (
              <div
                key={index}
                className="relative flex flex-col md:flex-row gap-6 items-start group"
              >
                {/* Number badge */}
                <div className="relative z-10 w-18 h-18 flex-shrink-0 hidden md:flex">
                  <div className="w-[72px] h-[72px] bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg group-hover:scale-110 transition-transform duration-300">
                    {step.number}
                  </div>
                </div>

                {/* Mobile number */}
                <div className="md:hidden flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 bg-teal-600 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                    {step.number}
                  </div>
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl text-teal-600`}></i>
                  </div>
                </div>

                {/* Content card */}
                <div className="flex-1 bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow ml-0 md:ml-0">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="hidden md:flex w-10 h-10 bg-teal-100 rounded-lg items-center justify-center flex-shrink-0">
                      <i className={`${step.icon} text-xl text-teal-600`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-[1.03] shadow-lg shadow-teal-600/25 cursor-pointer whitespace-nowrap"
          >
            Подобрать программу
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}